var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlast = function SvgBlast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFC03",
    d: "m69.61 49.552 11.93-5.944 4.111-12.623L77.428 25H22.663L10 34.406h64.373l-3.42 10.586H45.138l-2.483 7.736h25.814L61.222 75l12.092-5.985L77.63 55.66l-8.102-5.945z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFC03",
    d: "m28.202 65.43 7.45-23.208-8.265-6.189L14.97 75h46.254l3.094-9.568z"
  })));
};
export default SvgBlast;